(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auno-product-collection-link"] && !Shopify.designMode) return;
  try {
    
  /* Carrousel en boucle : les cartes sont dupliquées avant et après la liste ;
     quand on sort de la liste du milieu, on revient sans animation à la carte équivalente. */
  if (!customElements.get('auno-loop-carousel')) {
    customElements.define(
      'auno-loop-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-auno-track]');
          if (!this.track || this.track.dataset.looped) return;
          const originals = [...this.track.children];
          if (originals.length < 2) return;
          this.track.dataset.looped = 'true';

          const clone = (slide) => {
            const copy = slide.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
            copy.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'eager'));
            return copy;
          };
          /* Peu de produits : on répète la liste pour que la boucle remplisse toujours la largeur */
          const base = [...originals];
          while (base.length < 8) {
            const extra = originals.map(clone);
            this.track.append(...extra);
            base.push(...extra);
          }
          this.track.prepend(...base.map(clone));
          this.track.append(...base.map(clone));
          this.first = originals[0];

          const start = () => this.jump(this.setWidth());
          requestAnimationFrame(start);
          window.addEventListener('resize', () => this.recenter(), { passive: true });

          let timer = 0;
          const settle = () => this.recenter();
          if ('onscrollend' in window) {
            this.track.addEventListener('scrollend', settle);
          } else {
            this.track.addEventListener('scroll', () => {
              clearTimeout(timer);
              timer = setTimeout(settle, 140);
            }, { passive: true });
          }

          this.querySelector('[data-auno-prev]')?.addEventListener('click', () => this.step(-1));
          this.querySelector('[data-auno-next]')?.addEventListener('click', () => this.step(1));
        }

        /* Largeur d'un jeu complet de cartes (gap compris) */
        setWidth() {
          const firstClone = this.track.children[0];
          return this.first.offsetLeft - firstClone.offsetLeft;
        }

        step(direction) {
          const slide = this.first;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.recenter();
          this.track.scrollBy({ left: direction * (slide.offsetWidth + gap), behavior: 'smooth' });
        }

        recenter() {
          const width = this.setWidth();
          if (!width) return;
          const x = this.track.scrollLeft;
          let target = x;
          if (x < width * 0.5) target = x + width;
          else if (x >= width * 1.5) target = x - width;
          if (target !== x) this.jump(target);
        }

        /* Saut instantané : l'aimantation est coupée le temps du saut pour ne pas bloquer le clic suivant */
        jump(left) {
          this.track.style.scrollSnapType = 'none';
          this.track.scrollTo({ left, behavior: 'instant' });
          requestAnimationFrame(() => {
            this.track.style.scrollSnapType = '';
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
